import {FormatData} from 'notebook/mediocre/formatted-text/FormattersConstants';
import {DropdownItem, NoteToolbarProps} from 'notebook/notes/core-ui/NoteToolbar';
import {Note, NotePart} from 'notebook/util/NoteUtilConstants';

// Keep these in sync with document_parent.py
export enum CanvasType {
  NOTE = 'NOTE',
  GRID = 'GRID',
}

// Set of generic props that any Canvas rendering component is expected to support when rendering a document.
// These can be further extended to support more bespoke rendering options, but ideally, the bespoke rendering
// logic itself should be contained within the Canvas component and not elevated to the NoteEditor
export interface CanvasProps {
  renderedItems: Array<JSX.Element>;
  updateNote?: (note: Note) => void;
  note: Note;
  fileId: string;
  insertables: Array<DropdownItem>;
  insertFormat: (format: string, data: FormatData) => void;
  toolbarProps: NoteToolbarProps;
  replaceItems: (index: number, deleteCount: number, ...items: Array<NotePart>) => void;
  itemAtIndex: (index: number) => NotePart;
}

export const MAX_GRID_TITLE_NAME_LENGTH = 140;

interface CanvasSourceObject {
  apiIdentifier: string;
  name: string;
  url: string;
}

export interface CanvasTitleProps {
  fileId: string;
  updateTitle: (newTitle: string) => Promise<void>;
  title?: string;
  source?: CanvasSourceObject;
  parentApiIdentifier?: string;
  titleDisabled?: boolean;
}

export type CanvasRenderer = (props: CanvasProps) => JSX.Element;

export type CanvasTitleRenderer = (props: CanvasTitleProps) => JSX.Element;

export interface CanvasConfig {
  type: CanvasType;
  parentApiIdentifier?: string;
  source?: CanvasSourceObject;
}
